module.exports = {
  async getProfileOptions(params) {
    const url = `${this.url}/${this.version}/profile_options`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/profile_option_api.js